import { withRootServices } from 'v5/services/services.connected.app';
import { NotFoundScreen } from './NotFoundScreen';

export default withRootServices(NotFoundScreen);
